<div class="checkout-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">

    <!-- Header -->
    <div class="checkout-header" cdkDragHandle>
        <div class="checkout-header__title">
            <span class="checkout-header__main">
                {{ (isCancellationMode ? 'accounting.checkout.cancellationTitle' : 'accounting.checkout.title') | translate }}
            </span>
            <span class="checkout-header__sub" *ngIf="receipt?.receiptNumber">
                {{ 'accounting.checkout.receiptNumberPrefix' | translate }}{{ receipt.receiptNumber }}
            </span>
            <span class="checkout-header__sub" *ngIf="isCancellationMode && receiptToCancel?.receiptNumber">
                {{ 'accounting.checkout.cancelReceiptPrefix' | translate }}{{ receiptToCancel.receiptNumber }}
            </span>
        </div>
        <button type="button" class="checkout-header__close" (click)="close()" [disabled]="isProcessing || isPrinting">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Zahlart-Tabs -->
    <div class="checkout-tabs" *ngIf="!isCancellationMode">
        <button type="button" class="checkout-tab"
                [class.checkout-tab--active]="paymentType === TsePaymentType.CASH"
                [disabled]="!!receiptToCancel && receiptToCancel?.paymentType !== 'cash'"
                (click)="paymentType = TsePaymentType.CASH">
            <mat-icon>payments</mat-icon>
            {{ 'accounting.checkout.tab.cash' | translate }}
        </button>
        <button type="button" class="checkout-tab"
                [class.checkout-tab--active]="paymentType === TsePaymentType.EC_CARD || paymentType === TsePaymentType.CREDIT_CARD"
                [disabled]="!!receiptToCancel && receiptToCancel?.paymentType !== 'ecCard' && receiptToCancel?.paymentType !== 'creditCard'"
                (click)="paymentType = paymentType === TsePaymentType.CREDIT_CARD ? TsePaymentType.CREDIT_CARD : TsePaymentType.EC_CARD">
            <mat-icon>credit_card</mat-icon>
            {{ 'accounting.checkout.tab.card' | translate }}
        </button>
    </div>

    <div class="checkout-cancellation-payment-type" *ngIf="isCancellationMode">
        <mat-icon>{{ paymentType === TsePaymentType.CASH ? 'payments' : 'credit_card' }}</mat-icon>
        <span>{{ cancellationPaymentTypeLabelKey | translate }}</span>
    </div>

    <!-- Status-Meldungen (Prüfungen / Fehler) -->
    <div class="checkout-status" *ngIf="!canStartPaymentProcess || recipientErrors.length > 0 || receiptErrorMessages?.length > 0">
        <div class="checkout-status__checks">
            <div class="checkout-status__item" *ngIf="!checkAddonDone">
                <mat-spinner [diameter]="18"></mat-spinner>
                <span>{{ 'accounting.checkout.status.checkingAddon' | translate }}</span>
            </div>
            <div class="checkout-status__item checkout-status__item--error" *ngIf="checkAddonDone && !addonStatus">
                <mat-icon>error</mat-icon>
                <span>{{ 'accounting.checkout.status.addonDisabled' | translate }}</span>
            </div>
            <div class="checkout-status__item" *ngIf="addonStatus && !checkCashRegisterDone">
                <mat-spinner [diameter]="18"></mat-spinner>
                <span>{{ 'accounting.checkout.status.checkingCashRegister' | translate }}</span>
            </div>
            <div class="checkout-status__item checkout-status__item--ok" *ngIf="checkCashRegisterDone && cashRegister?.id">
                <mat-icon>check_circle</mat-icon>
                <span>{{ 'accounting.checkout.status.cashRegisterLabel' | translate }}{{ cashRegister.title }}</span>
            </div>
            <ng-container *ngFor="let error of recipientErrors">
                <div class="checkout-status__item checkout-status__item--error">
                    <mat-icon>error</mat-icon>
                    <span>{{ error }}</span>
                </div>
            </ng-container>
            <ng-container *ngIf="cashRegister?.id && (isProcessing || requestReceiptDone || receiptErrorMessages?.length > 0)">
                <div class="checkout-status__item" *ngIf="isProcessing && !requestReceiptDone">
                    <mat-spinner [diameter]="18"></mat-spinner>
                    <span>{{ 'accounting.checkout.status.creatingReceipt' | translate }}</span>
                </div>
                <div class="checkout-status__item checkout-status__item--ok" *ngIf="requestReceiptDone && receipt?.id">
                    <mat-icon>check_circle</mat-icon>
                    <span>{{ 'accounting.checkout.status.receiptNumberLabel' | translate }}{{ receipt.receiptNumber }}</span>
                </div>
                <ng-container *ngFor="let error of (receiptErrorMessages || [])">
                    <div class="checkout-status__item checkout-status__item--error">
                        <mat-icon>error</mat-icon>
                        <span>{{ error }}</span>
                    </div>
                </ng-container>
                <div class="checkout-status__item checkout-status__item--hint" *ngIf="showReceiptCreationErrorHint && !receiptCreationLocked">
                    <mat-icon>info</mat-icon>
                    <span>{{ 'accounting.checkout.hint.receiptNotCreated' | translate }}</span>
                </div>
                <div class="checkout-status__item checkout-status__item--hint" *ngIf="receiptCreationLocked">
                    <mat-icon>info</mat-icon>
                    <span>{{ 'accounting.checkout.hint.tseSignedNoRetry' | translate }}</span>
                </div>
                <div class="checkout-status__item checkout-status__item--error" *ngIf="printFailed && receipt?.receiptNumber">
                    <mat-icon>error</mat-icon>
                    <span>{{ 'accounting.checkout.status.printFailed' | translate:{ receiptNumber: receipt.receiptNumber } }}</span>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Hauptbereich -->
    <div class="checkout-body" *ngIf="canStartPaymentProcess">

        <!-- Zu Zahlen -->
        <div class="checkout-amount-due">
            <span class="checkout-amount-due__label">{{ 'accounting.checkout.amountDue' | translate }}</span>
            <span class="checkout-amount-due__value">{{ totalSum | bcmDynamicCurrency }}</span>
        </div>

        <!-- ── BARZAHLUNG ── -->
        <ng-container *ngIf="paymentType === TsePaymentType.CASH && !isCancellationMode">

            <div class="checkout-cash-section">

                <!-- Linke Spalte: Gegeben / Rückgeld / Quick-Buttons -->
                <div class="checkout-cash-left">

                    <div class="checkout-field checkout-field--given">
                        <span class="checkout-field__label">{{ 'accounting.checkout.given' | translate }}</span>
                        <span class="checkout-field__value">{{ givenAmount | bcmDynamicCurrency }}</span>
                    </div>

                    <div class="checkout-quick-buttons">
                        <button type="button" class="checkout-quick-btn" (click)="setQuickAmount(5)">5€</button>
                        <button type="button" class="checkout-quick-btn" (click)="setQuickAmount(10)">10€</button>
                        <button type="button" class="checkout-quick-btn" (click)="setQuickAmount(20)">20€</button>
                        <button type="button" class="checkout-quick-btn" (click)="setQuickAmount(50)">50€</button>
                    </div>

                    <button type="button" class="checkout-exact-btn" (click)="setExactAmount()">
                        {{ 'accounting.checkout.exactChange' | translate }}
                    </button>

                    <div class="checkout-field checkout-field--change-positive">
                        <span class="checkout-field__label">{{ 'accounting.checkout.change' | translate }}</span>
                        <span class="checkout-field__value">{{ changeAmount | bcmDynamicCurrency }}</span>
                    </div>

                </div>

                <!-- Rechte Spalte: Numpad -->
                <div class="checkout-numpad">
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('1')">1</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('2')">2</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('3')">3</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('4')">4</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('5')">5</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('6')">6</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('7')">7</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('8')">8</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('9')">9</button>
                    <button type="button" class="numpad-btn numpad-btn--clear" (click)="onNumpadKey('C')">C</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey('0')">0</button>
                    <button type="button" class="numpad-btn" (click)="onNumpadKey(',')">&#44;</button>
                </div>

            </div>

        </ng-container>

        <!-- ── KARTENZAHLUNG ── -->
        <ng-container *ngIf="(paymentType === TsePaymentType.EC_CARD || paymentType === TsePaymentType.CREDIT_CARD) && !isCancellationMode">

            <div class="checkout-card-section">
                <div class="checkout-card-type__options">
                    <button type="button" class="checkout-card-type__btn"
                            [class.checkout-card-type__btn--active]="paymentType === TsePaymentType.EC_CARD"
                            (click)="paymentType = TsePaymentType.EC_CARD">
                        <mat-icon>credit_card</mat-icon>
                        {{ 'accounting.checkout.cardType.ec' | translate }}
                    </button>
                    <button type="button" class="checkout-card-type__btn"
                            [class.checkout-card-type__btn--active]="paymentType === TsePaymentType.CREDIT_CARD"
                            (click)="paymentType = TsePaymentType.CREDIT_CARD">
                        <mat-icon>payment</mat-icon>
                        {{ 'accounting.checkout.cardType.credit' | translate }}
                    </button>
                </div>
            </div>

        </ng-container>

        <!-- Bondrucker (Bar-Storno) -->
        <div class="checkout-printer" *ngIf="isCancellationMode && paymentType === TsePaymentType.CASH && receiptPrintersLoaded">
            <label class="checkout-printer__label">
                {{ 'accounting.financialDocuments.invoiceForm.meta.receiptPrinter' | translate }}
            </label>
            <select class="checkout-printer__select"
                    [ngModel]="selectedReceiptPrinter"
                    (ngModelChange)="onReceiptPrinterChange($event)"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="isProcessing || isPrinting || !!receipt?.id">
                <option [ngValue]="null">
                    {{ 'accounting.financialDocuments.invoiceForm.receiptPrinter.a4Default' | translate }}
                </option>
                <option *ngFor="let printer of receiptPrinters" [ngValue]="printer">
                    {{ printer.name }}<ng-container *ngIf="printer.location"> ({{ printer.location }})</ng-container>
                </option>
            </select>
            <label class="checkout-printer__checkbox">
                <input type="checkbox"
                       [(ngModel)]="printCancellationReceipt"
                       [ngModelOptions]="{standalone: true}"
                       [disabled]="isProcessing || isPrinting || !!receipt?.id">
                <span>{{ 'accounting.checkout.printCancellationReceipt' | translate }}</span>
            </label>
        </div>

        <!-- Kassenbenutzer -->
        <div class="checkout-user" *ngIf="cashRegister?.currentUser">
            <span class="checkout-user__name">{{ cashRegister.currentUser.fullName }}</span>
            <span class="checkout-user__status">{{ 'accounting.checkout.user.loggedIn' | translate }}</span>
        </div>

        <!-- Aktions-Buttons -->
        <div class="checkout-actions">
            <ng-container *ngIf="printFailed && receipt?.id; else defaultCheckoutActions">
                <button type="button" class="checkout-btn--confirm"
                        [disabled]="isPrinting"
                        (click)="retryPrint()">
                    <ng-container *ngIf="!isPrinting">
                        <mat-icon>print</mat-icon>
                        {{ 'accounting.checkout.action.retryPrint' | translate }}
                    </ng-container>
                    <ng-container *ngIf="isPrinting">
                        <mat-spinner [diameter]="24" color="primary"></mat-spinner>
                        <span>{{ 'accounting.checkout.status.sendingPrint' | translate }}</span>
                    </ng-container>
                </button>
                <button type="button" class="checkout-btn--secondary"
                        [disabled]="isPrinting"
                        (click)="finishWithoutPrint()">
                    <mat-icon>check_circle</mat-icon>
                    {{ 'accounting.checkout.action.finishWithoutPrint' | translate }}
                </button>
            </ng-container>

            <ng-template #defaultCheckoutActions>
                <button type="button" class="checkout-btn--confirm"
                        [disabled]="isProcessing || isPrinting || receiptCreationLocked || recipientErrors?.length > 0 || !cashRegister?.id"
                        (click)="startPaymentProcess()">
                    <ng-container *ngIf="!isProcessing && !isPrinting">
                        <mat-icon>{{ shouldPrint ? 'print' : 'check_circle' }}</mat-icon>
                        {{ shouldPrint
                            ? (isCancellationMode
                                ? ('accounting.checkout.action.completeCancellationAndPrint' | translate)
                                : (showReceiptCreationErrorHint && !receiptCreationLocked
                                    ? ('accounting.checkout.action.retryPayment' | translate)
                                    : ('accounting.checkout.action.print' | translate)))
                            : ((isCancellationMode ? 'accounting.checkout.action.completeCancellation' : 'accounting.checkout.action.completePayment') | translate) }}
                    </ng-container>
                    <ng-container *ngIf="isProcessing || isPrinting">
                        <mat-spinner [diameter]="24" color="primary"></mat-spinner>
                        <span>{{ isPrinting
                            ? ('accounting.checkout.status.sendingPrint' | translate)
                            : ('accounting.checkout.status.processing' | translate) }}</span>
                    </ng-container>
                </button>
                <button type="button" class="checkout-btn--secondary"
                        *ngIf="showReceiptCreationErrorHint"
                        [disabled]="isProcessing || isPrinting"
                        (click)="cancelCheckout()">
                    {{ 'accounting.checkout.action.cancel' | translate }}
                </button>
            </ng-template>
        </div>

    </div>

</div>
